<form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" *ngIf="!success">
    <h1 [innerHTML]="translationPrefix + '.title' | translate"></h1>
    <div class="reset-password-wrapper">
        <div
            class="form-group"
            [class.active]="hasFocusNewPassword || hasValue(f.newPassword)"
            [class.hasvalue]="!hasFocusNewPassword && hasValue(f.newPassword)"
        >
            <label
                for="newPassword"
                [class.active]="hasFocusNewPassword || hasValue(f.newPassword)"
                [class.hasvalue]="!hasFocusNewPassword && hasValue(f.newPassword)"
            >
                <span class="labelcontent"><span [innerHTML]="translationPrefix + '.newPassword' | translate"></span></span>
                <input
                    formControlName="newPassword"
                    id="newPassword"
                    (focus)="hasFocusNewPassword = true"
                    (blur)="hasFocusNewPassword = false"
                    type="password"
                />
            </label>
            <div *ngIf="submitted && (f.newPassword.errors || showMessage)" class="invalid-feedback">
                <div
                    *ngIf="f.newPassword.errors && f.newPassword.errors.required"
                    [innerHTML]="translationPrefix + '.newPasswordRequired' | translate"
                ></div>
                <div
                    *ngIf="f.newPassword.errors && f.newPassword.errors.pattern"
                    [innerHTML]="translationPrefix + '.mustMatchPatter' | translate"
                ></div>
            </div>
        </div>

        <div
            class="form-group"
            [class.active]="hasFocusRenewPassword || hasValue(f.renewPassword)"
            [class.hasvalue]="!hasFocusRenewPassword && hasValue(f.renewPassword)"
        >
            <label
                for="renewPassword"
                [class.active]="hasFocusRenewPassword || hasValue(f.renewPassword)"
                [class.hasvalue]="!hasFocusRenewPassword && hasValue(f.renewPassword)"
            >
                <span class="labelcontent"><span [innerHTML]="translationPrefix + '.renewPassword' | translate"></span></span>
                <input
                    formControlName="renewPassword"
                    id="renewPassword"
                    (focus)="hasFocusRenewPassword = true"
                    (blur)="hasFocusRenewPassword = false"
                    type="password"
                />
            </label>
            <div *ngIf="submitted && (f.renewPassword.errors || showMessage)" class="invalid-feedback">
                <div
                    *ngIf="f.renewPassword.errors && f.renewPassword.errors.required"
                    [innerHTML]="translationPrefix + '.renewPasswordRequired' | translate"
                ></div>
                <div
                    *ngIf="f.renewPassword.errors && f.renewPassword.errors.mustMatch"
                    [innerHTML]="translationPrefix + '.mustMatch' | translate"
                ></div>
            </div>
        </div>
        <div class="legend" [innerHTML]="translationPrefix + '.legend' | translate"></div>

        <div class="button-wrapper">
            <a [routerLink]="linkPersonalData" class="secondary button" da-link
                ><span [innerHTML]="'forgotPassword.cancel' | translate"></span
            ></a>
            <button [disabled]="loaded$ | async" class="button primary">
                <span [innerHTML]="'forgotPassword.submit' | translate"></span>
            </button>
        </div>
        <div *ngIf="showMessage" class="error-message" [innerHTML]="translationPrefix + '.serverErrorMessage' | translate"></div>
    </div>
</form>
<ng-container *ngIf="success">
    <div class="success">
        <h1 [innerHTML]="translationPrefix + '.titleSuccess' | translate"></h1>
        <p class="large" [innerHTML]="translationPrefix + '.messageSuccess' | translate"></p>
        <div class="button-wrapper">
            <a [routerLink]="linkPersonalData" class="secondary button" da-link
                ><span [innerHTML]="'forgotPassword.backToPersonalData' | translate"></span
            ></a>
        </div>
    </div>
</ng-container>
<ng-template #resetPasswordPopup>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="resetPasswordModal"></ng-container>
    </div>
</ng-template>
<ng-template #resetPasswordModal>
    <div class="modal">
        <div class="popup-warning">
            <div class="details">
                <ng-container *ngIf="(passwordResetSuccess$ | async) === true">
                    <h3 [innerHTML]="translationPrefix + '.resetSuccessTitle' | translate"></h3>
                </ng-container>
                <ng-container *ngIf="(tokenIsInvalid$ | async) === true">
                    <h3 [innerHTML]="translationPrefix + '.tokenIsInvalid' | translate"></h3>
                    <p [innerHTML]="translationPrefix + '.tokenIsInvalidText' | translate"></p>
                </ng-container>
                <ng-container *ngIf="(passwordResetError$ | async) === true">
                    <h3 [innerHTML]="translationPrefix + '.resetErrorTitle' | translate"></h3>
                    <p [innerHTML]="translationPrefix + '.resetErrorMessage' | translate"></p>
                </ng-container>
                <div class="button-container">
                    <div class="button-wrapper">
                        <a *ngIf="(passwordResetSuccess$ | async) === false"
                            class="button primary"
                            da-link
                            [routerLink]="linkForgotPassword"
                            da-link
                            (click)="goToForgotPasswordPage()"
                            [innerHTML]="translationPrefix + '.goToForgotPasswordPage' | translate"
                        ></a>
                        <a *ngIf="(passwordResetSuccess$ | async) === true"
                        class="button primary"
                        da-link
                        [routerLink]="targetLink "
                        da-link
                        (click)="goToLoginPage()"
                        [innerHTML]="translationPrefix + '.goToLoginPage' | translate"
                    ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
